import { IconButton, Radio, RadioGroup, Stack, Text } from '@chakra-ui/react';
import { HiChevronLeft } from 'react-icons/hi';

import { QuoteFilters } from '.';

type Props = {
  filters: QuoteFilters;
  handleFilterChange: (key: string) => (nextValue: string) => void;
  resetView: () => void;
};

export const StopFilter = ({ filters, handleFilterChange, resetView }: Props) => {
  return (
    <Stack>
      <Stack direction="row" align="center" spacing="2">
        <IconButton
          aria-label="Go back"
          icon={<HiChevronLeft />}
          variant="link"
          size="sm"
          display={{ base: 'flex', md: 'none' }}
          minW="auto"
          onClick={resetView}
        />
        <Text textStyle="label">Stops</Text>
      </Stack>

      <RadioGroup value={filters?.stops} onChange={handleFilterChange('stops')}>
        <Stack>
          <Radio value="any">Any number of stops</Radio>
          <Radio value="nonstop">Nonstop only</Radio>
        </Stack>
      </RadioGroup>
    </Stack>
  );
};
